import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { PenaltyShootoutScoreboardStats } from '../../../../scoreboards/models/scoreboard-stats';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    templateUrl: './my-bets-penalty-shootout-scoreboard-stats.component.html',
    selector: 'ms-my-bets-penalty-shootout-scoreboard-stats',
    standalone: false,
})
export class MyBetsPenaltyShootoutScoreboardStatsComponent {
    vm = input.required<PenaltyShootoutScoreboardStats>();
}
